
document.addEventListener('DOMContentLoaded', () => {
  const widgets = document.querySelectorAll('#shoppyc-clickcollect');
  widgets.forEach(widget => {
    // Remove all existing <style> tags
    widget.querySelectorAll('style').forEach(styleTag => {
      styleTag.remove();
    });
    // Observe future additions of <style> tags
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.tagName === 'STYLE') {
            node.remove();
          }
        });
      });
    });
    observer.observe(widget, { childList: true });
  });

  

  // Mobile : Move tabs from product informations to tabs section
  const host = document.querySelector('[data-product-informations-tabs-host]');
  const receiver = document.querySelector('[data-product-informations-tabs-receiver]');
  if (host && receiver && window.innerWidth < 1024) {
    receiver.appendChild(host);
  }

  // For each tabs-section, handle tabs independently
  document.querySelectorAll('.tabs-section').forEach((section) => {
    const tabButtons = Array.from(section.querySelectorAll('.tab-button[data-tab-index]'));
    const tabContents = Array.from(section.querySelectorAll('.content'));
    const tabsImageRoot = section.querySelector('.tabs_image');
    const tabMediaSlots = tabsImageRoot
      ? Array.from(tabsImageRoot.children)
      : [];

    const showTab = (index) => {
      tabContents.forEach(content => {
        content.style.display = 'none';
      });
      tabMediaSlots.forEach((slot) => {
        slot.style.display = 'none';
      });
      tabButtons.forEach(button => {
        button.classList.remove('tab-button__selected');
        const heading = button.querySelector('h5');
        if (heading) heading.classList.remove('tab-button__selected');
      });
      const selectedContent = section.querySelector('.content[data-tab-index="' + index + '"]');
      if (selectedContent) selectedContent.style.display = 'block';
      if (tabsImageRoot) {
        const selectedSlot = tabsImageRoot.querySelector(
          ':scope > [data-tab-index="' + index + '"]'
        );
        if (selectedSlot) selectedSlot.style.removeProperty('display');
      }
      const selectedButton = section.querySelector('.tab-button[data-tab-index="' + index + '"]');
      if (selectedButton) {
        selectedButton.classList.add('tab-button__selected');
        const heading = selectedButton.querySelector('h5');
        if (heading) heading.classList.add('tab-button__selected');
      }
    };

    tabButtons.forEach((button) => {
      const index = button.getAttribute('data-tab-index');
      button.addEventListener('click', () => {
        if (index !== null) showTab(index);
      });
    });

    // Show the first tab actually rendered for this section
    if (tabButtons.length > 0) {
      const firstIndex = tabButtons[0].getAttribute('data-tab-index');
      showTab(firstIndex);
    }
  });
});
